// Opening the calendar is optional enhancement; a browser rejection must not
// interrupt booking or discard the values already entered by the customer.
export function openDatePicker(event) {
  const input = event.currentTarget;
  if (typeof input?.showPicker !== 'function') return;
  try {
    input.showPicker();
  } catch (_error) {
    // Keep the native date input usable (keyboard or built-in calendar button).
  }
}
